import { createContext, useContext, useEffect, useState } from 'react';
import { login as apiLogin, getMe } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('kortex_token');
    if (!token) return setReady(true);
    getMe()
      .then(setUser)
      .catch(() => localStorage.removeItem('kortex_token'))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { user: u, token } = await apiLogin({ email, password });
    if (u.role !== 'admin') {
      throw new Error('This account is not an admin.');
    }
    localStorage.setItem('kortex_token', token);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('kortex_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
